/* eslint-disable prettier/prettier */
import React, { useState, useEffect, useMemo } from "react";
import { Redirect } from "react-router";
import {
  db,
  firebase,
  storage,
  sendDynamicEmail,
  sendSMS,
} from "firebase/fbConfig.js";
import { connect } from "react-redux";
import axios from "axios";
import compose from "recompose/compose";
import _ from "lodash";
import moment from "moment";
import { v1 as uuidv1 } from "uuid";
import jsPDF from "jspdf";
import { Link } from "react-router-dom";

import DateTimePicker from "react-datetime-picker";


import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "@material-ui/core/Card";
import FormControl from "@material-ui/core/FormControl";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import withStyles from "@material-ui/core/styles/withStyles";
import Snackbar from "@material-ui/core/Snackbar";
import IconButton from "@material-ui/core/IconButton";
import Switch from "@material-ui/core/Switch";
import Divider from "@material-ui/core/Divider";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Hidden from "@material-ui/core/Hidden";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import FormLabel from "@material-ui/core/FormLabel";
import { makeStyles } from '@material-ui/core/styles';

//---
import Check from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import LeftArrowIcon from "@material-ui/icons/ChevronLeft";
import RightArrowIcon from "@material-ui/icons/ChevronRight";

import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import PrototypeExploreAssignUser from "views/Explore/PrototypeExploreAssignUser.jsx";

const useStyles = makeStyles(theme => ({
    fullView: {
        overflow: 'auto'
    },
}))

export default function OrderCard({
  order,
  tripOrder,
  orderQuantity,
  orderIndex,
  tripRate,
  orderRate,
  remove,
  classes,
  toggleBOL,
  handleChangeRate,
  handleSwitchChangeOrder,
  handleChangeLegType,
  isPickUp,
  isDropOff,
  pickUpLocation,
  dropOffLocation,
  assignBusiness,
  handleChangeTripOrderPickUpLocation,
  handleChangeTripOrderDropOffLocation,
  handleDateTimeTripOrderPickUpChange,
  handleDateTimeTripOrderDropOffChange,
  pickUpBy,
  dropOffBy,
  rearrangeSelectedOrders,
  handleClearPickUp,
  handleClearDropOff,
}) {
  const fullClasses = useStyles();
  const [isDollar, setIsDollar] = useState(true);
  const [isEditOrder, setIsEditOrder] = useState((order.isDropOff || order.isPickUp) ? true : false);
  const [pickUpQuery, setPickUpQuery] = useState('');
  const [dropOffQuery, setDropOffQuery] = useState('');
  const [financials, setFinancials] = useState({
    revenue: 0,
    expenses: 0,
    cmTotal: 0,
    cmPercent: 0
  });
  const rate = isDollar ? orderRate : (orderRate / parseFloat(tripRate)) * 100;

  const GetAddress = ({ location }) => {
    switch (location) {
      case 'origin':

        if (order.pickUpLocation && order.isPickUp && ['address', 'city', 'state', 'zip'].every(key => order.pickUpLocation[key])) return (
          <p>{order.pickUpLocation.address} {order.pickUpLocation.city}, {order.pickUpLocation.state} {order.pickUpLocation.zip}</p>
        );

        if (isPickUp && pickUpLocation && ['address', 'city', 'state', 'zip'].every(key => pickUpLocation[key])) return (
          <p>{pickUpLocation.address} {pickUpLocation.city}, {pickUpLocation.state} {pickUpLocation.zip}</p>
        )

        return (
          <p></p>
        );

      case 'destination':

        if (order.dropOffLocation && order.isDropOff && ['address', 'city', 'state', 'zip'].every(key => order.dropOffLocation[key])) return (
          <p>{order.dropOffLocation.address} {order.dropOffLocation.city}, {order.dropOffLocation.state} {order.dropOffLocation.zip}</p>
        );

        if (isDropOff && dropOffLocation && ['address', 'city', 'state', 'zip'].every(key => dropOffLocation[key])) return (
          <p>{dropOffLocation.address} {dropOffLocation.city}, {dropOffLocation.state} {dropOffLocation.zip}</p>
        )

        return (
          <p></p>
        );
    }

    return null;
  }

  const GetDate = ({ location }) => {
    switch (location) {
      case 'origin':

        if (order.pickUpBy && order.isPickUp) return (
          <p>Pick Up At {moment(order.pickUpBy).format('YYYY-MM-DD HH:mm')}</p>
        );

        if (isPickUp && pickUpBy) return (
          <p>Pick Up At {moment(pickUpBy).format('YYYY-MM-DD HH:mm')}</p>
        );

        break;

      case 'destination':

        if (order.dropOffBy && order.isDropOff) return (
          <p>Drop Off At {moment(order.dropOffBy).format('YYYY-MM-DD HH:mm')}</p>
        );

        if (isDropOff && dropOffBy) return (
          <p>Drop Off At {moment(dropOffBy).format('YYYY-MM-DD HH:mm')}</p>
        );

        break;
    }

    return null
  }

  const countDecimals = (num) => {
    if (num % 1 != 0)
      return num.toString().split(".")[1]
        ? num.toString().split(".")[1].length
        : null;
    return 0;
  };

  const toggleRateType = (e) => {
    e.stopPropagation();
    setIsDollar((prevState) => !prevState);
  };

  const legTypes = ["", "Local", "Brokered", "Inbound", "Outbound", "Skip", "Relay", "Backhaul", "Trailer Drop", "Trailer Pick"];

  useEffect(() => {
    db.collection("haney-orders").doc(order.id).collection("register").get()
      .then(snapshot => {
        // Get register data
        const data = snapshot.docs.map(doc => ({
          ...doc.data(),
          id: doc.id
        }));

        let totalRevenue = 0;
        let totalExpenses = 0;

        for (let i = 0; i < data.length; i++) {

          const row = data[i];

          // Add to revenue or expenses
          if (row.category === "revenue") {
            totalRevenue += parseFloat(row.dollarAmount);
          } else if (row.category === "expense") {
            totalExpenses += parseFloat(row.dollarAmount);
          } else if (row.category === "customer discount") {
            totalRevenue -= parseFloat(row.dollarAmount);
          } else if (row.category === "vendor credit") {
            totalExpenses -= parseFloat(row.dollarAmount);
          }

          if (
            row.dollarAmount.toString().includes(".") &&
            row.dollarAmount.toString().split(".")[1].length === 1
          ) {
            row.dollarAmount = `${row.dollarAmount}0`;
          } else if (!row.dollarAmount.toString().includes(".")) {
            row.dollarAmount = `${row.dollarAmount}.00`;
          }
        }

        const cmTotal = totalRevenue - totalExpenses;
        const cmPercent = totalRevenue === 0 ? (0).toFixed(2) : ((cmTotal / totalRevenue) * 100).toFixed(2);

        setFinancials({
          revenue: totalRevenue.toFixed(2),
          expenses: totalExpenses.toFixed(2),
          cmTotal: cmTotal.toFixed(2),
          cmPercent
        });

      });
  }, []);

  return (
    <Card
      component={GridItem}
      xs={12}
      // onClick={expander}
      style={{
        overflow: 'visible',
        padding: "8px",
        marginBottom: "16px",
        transition: "all 0.3s ease-in-out",
      }}
    >
      <GridContainer>
        <GridItem xs={12}>
          <GridContainer justify="space-between" alignItems="center">
            {/* <GridItem>
              <FormControlLabel
                control={
                  <Checkbox
                    tabIndex={-1}
                    onClick={toggleBOL}
                    checked={order.generateBOL ? true : false}
                    checkedIcon={
                      <Check
                        className={classes.checkedIcon}
                        style={{ color: "limegreen" }}
                      />
                    }
                    icon={<Check className={classes.uncheckedIcon} />}
                    // color="secondary"
                    classes={{
                      checked: classes.checked,
                      root: classes.checkRoot,
                    }}
                  />
                }
                classes={{ label: classes.bodyText }}
                label="BOL"
              />
            </GridItem> */}
            <GridItem>
              <IconButton onClick={remove}>
                <CloseIcon color="secondary" />
              </IconButton>
            </GridItem>
            <GridItem xs={12}>
              <Divider
                style={{
                  marginBottom: "8px",
                  backgroundColor: order.generateBOL ? "limegreen" : "",
                  transition: "all 0.3s ease-in-out",
                }}
              />
            </GridItem>
          </GridContainer>
        </GridItem>
        <GridItem xs={12}>
         {/*  <GridContainer justify="center" alignItems="center">
            <GridItem>
              <IconButton
                onClick={(e) => rearrangeSelectedOrders(-1, orderIndex, e)}
                disabled={orderIndex === 0}
              >
                <LeftArrowIcon />
              </IconButton>
            </GridItem>
            <GridItem>
              <p style={{ margin: "0" }}>
                <b>Stop #{orderIndex + 1}</b>
              </p>
            </GridItem>
            <GridItem>
              <IconButton
                onClick={(e) => rearrangeSelectedOrders(1, orderIndex, e)}
                disabled={orderIndex + 1 === orderQuantity}
              >
                <RightArrowIcon />
              </IconButton>
            </GridItem>
          </GridContainer>*/}
          <p>{order.id}</p>
          <p>
            <b>ORDER # {order.freightBillNumber}</b> - {order.status}
          </p>
        </GridItem> 
        <GridItem xs={12}>
          <GridContainer>
            <GridItem xs={6}>
              <p>
                Revenue:{" "}
                <b>${financials.revenue}</b>
              </p>
            </GridItem>
            <GridItem xs={6}>
              <p>
                Expenses:{" "}
                <b>
                  ${financials.expenses}
                </b>
              </p>
            </GridItem>
          </GridContainer>
          <GridContainer>
            <GridItem xs={6}>
              <p>
                CM$: <b>${financials.cmTotal}</b>
              </p>
            </GridItem>
            <GridItem xs={6}>
              <p>
                CM%: <b>{financials.cmPercent}%</b>
              </p>
            </GridItem>
          </GridContainer>
        </GridItem>
        <GridItem xs={6}>
          <p>
            Total Pieces: <b>{order.totals.quantity}</b>
          </p>
        </GridItem>
        <GridItem xs={6}>
          <p>
            Total Weight: <b>{order.totals.weight}</b>
          </p>
        </GridItem>
        <GridItem xs={6}>
          <p>
            Mode:  <b>{order.deliveryType}</b>
          </p>
        </GridItem>
        <GridItem xs={6}>
          {/* empty Grid item to keep spacing and alignment */}
          <p>

          </p>
        </GridItem>
        <React.Fragment>
          <GridItem xs={6}>
            <p>
              <b>Origin:</b>
            </p>
            <p>{order.origin.businessName}</p>
            <p>{order.origin.address}</p>
            <p>{order.origin.city} {order.origin.state} {order.origin.zip}</p>
            <p>Pick Up At {order.pickUpDate}</p>
          </GridItem>
          <GridItem xs={6}>
            <p>
              <b>Destination:</b>
            </p>
            <p>{order.destination.businessName}</p>
            <p>{order.destination.address}</p>
            <p>{order.destination.city} {order.destination.state} {order.destination.zip}</p>
            <p>Drop Off At {order.serviceETA ? order.serviceETA : null}</p>
          </GridItem>
        </React.Fragment>
        <GridItem xs={12} style={{ marginBottom: "15px" }}>
          <Divider orientation="horizontal" variant="fullWidth" />
        </GridItem>
        {/* {console.log("WHY", pickUpLocation, dropOffLocation)} */}

        {order.isPickUp ?
          (<GridItem xs={6}>
            <p>
              <b>Alternate Origin</b>
            </p>
            {order.pickUpLocation && (
              <React.Fragment>
                {order.pickUpLocation && (<p>{order.pickUpLocation.entityName}</p>)}
                <GetAddress location="origin" />
                <GetDate location="origin" />
              </React.Fragment>
            )
            }

          </GridItem>)
          : isPickUp ? (
            <GridItem xs={6}>
              <p>
                <b>Alternate Origin</b>
              </p>
              {
                pickUpLocation && (<p>{pickUpLocation.entityName}</p>)
              }
              <GetAddress location="origin" />
              <GetDate location="origin" />
            </GridItem>

          ) : null

        }
        {order.isDropOff ? (
          <GridItem xs={6} >
            <p>
              <b>Alternate Destination</b>
            </p>
            {order.dropOffLocation && (
              <React.Fragment>
                {order.dropOffLocation && (<p>{order.dropOffLocation.entityName}</p>)}
                <GetAddress location="destination" />
                <GetDate location="destination" />
              </React.Fragment>)
            }
          </GridItem>
        ) : isDropOff ? (
          <GridItem xs={6} >
            <p>
              <b>Alternate Destination</b>
            </p>
            {isDropOff && dropOffLocation && (<p>{dropOffLocation.entityName}</p>)}
            <GetAddress location="destination" />
            <GetDate location="destination" />
          </GridItem>
        ) : null
        }

        {/* <GridItem xs={6}>
          <Button
            onClick={() => {
              order.pickUpLocation ? (order.isPickUp = true) : (order.isPickUp = false)
              order.dropOffLocation ? (order.isDropOff = true) : (order.isDropOff = false)
              setIsEditOrder(!isEditOrder)
              // console.log(isEditOrder)
            }
            }
            color="success">Edit Order</Button>
        </GridItem> */}
        <GridItem xs={6}>
          <Link to={`/order/${order.id}`}>
            <Button color="info">GO TO ORDER</Button>
          </Link>
        </GridItem>
        {/* {order.bolHash && (
                                            <GridItem xs={6}>
                                              <a
                                                href={`https://api.eversign.com/api/download_current_document_status?access_key=751efbc709ec4ace1d6ff70a062b7243&business_id=246480&document_hash=${order.bolHash}&audit_trail=1`}
                                                target="_blank"
                                              >
                                                <Button color="success">
                                                
                                                  PRINT Bill of Lading'
                                                </Button>
                                              </a>
                                            </GridItem>
                                          )} */}
        {isEditOrder &&
          <GridItem xs={12}>
            <GridContainer>
              <GridItem xs>
                <b>Pick Up Location:</b>
                <FormControlLabel
                  control={
                    <Switch
                      checked={order.isPickUp}
                      onChange={handleSwitchChangeOrder("isPickUp", order.id)}
                      value="isPickUp"
                      classes={{
                        switchBase: classes.switchBase,
                        checked: classes.switchChecked,
                        icon: classes.switchIcon,
                        iconChecked: classes.switchIconChecked,
                        bar: classes.switchBar,
                      }}
                    />
                  }
                  classes={{
                    label: classes.label,
                  }}
                  style={{ marginLeft: "10px" }}
                />
              </GridItem>
              <GridItem xs>
                <b style={{ paddingRight: '20px' }}>Pick Up By:</b>
                <DateTimePicker
                  calendarClassName={`${fullClasses.fullView}`}
                  onChange={(date) => handleDateTimeTripOrderPickUpChange(date)}
                  value={order ? (order.pickUpBy ? order.pickUpBy : null) : (tripOrder ? (tripOrder.pickUpBy ? tripOrder.pickUpBy.toDate() : null) : null)}
                />
              </GridItem>
            </GridContainer>

            {order.isPickUp &&
              <GridContainer>
                <GridItem xs={12}>
                  <Divider />
                  <GridContainer xs={12} >
                    <GridItem xs={6}>
                      <br />
                      <p>
                        <b>Pick Up Location:</b>
                      </p>
                    </GridItem>
                    <GridItem xs={6} >
                      <Button color="primary"
                        onClick={() => handleClearPickUp(orderIndex)}
                      >Clear Location</Button>
                    </GridItem>



                  </GridContainer>
                </GridItem>
                <GridItem xs={12}>
                  <PrototypeExploreAssignUser
                    labelText={"Search Business Name"}
                    trip={true}
                    collection={"TEST-vendors"}
                    collection2={"TEST-shippers"}
                    id='pickUpQuery'
                    onChange={(e) => setPickUpQuery(e.target.value)}
                    value={pickUpQuery}
                    assignUser={(...args) => assignBusiness(...args, 'pickUp')}
                  />
                  {order.pickUpLocation &&
                    order.pickUpLocation.entityName && (
                      <p>{order.pickUpLocation.entityName}</p>
                    )}
                </GridItem>
                <GridItem xs={12}>
                  <CustomInput
                    labelText="Business Name"
                    id="entityName"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    labelProps={{
                      shrink: true
                    }}
                    inputProps={{
                      required: true,
                      onChange: (e) => handleChangeTripOrderPickUpLocation(e, "pickUp", orderIndex),
                      value: order ? (order.pickUpLocation ? order.pickUpLocation.entityName : null) : (tripOrder.pickUpLocation ? tripOrder.pickUpLocation.entityName : ""),
                    }}
                  />
                </GridItem>
                <GridItem xs={12}>
                  <CustomInput
                    labelText="Address"
                    id="address"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    labelProps={{
                      shrink: true
                    }}
                    inputProps={{
                      required: true,
                      onChange: (e) => handleChangeTripOrderPickUpLocation(e, "pickUp", orderIndex),
                      value: order ? (order.pickUpLocation ? order.pickUpLocation.address : null) : (tripOrder.pickUpLocation ? tripOrder.pickUpLocation.address : ""),
                    }}
                  />
                </GridItem>
                <GridItem xs={4}>
                  <CustomInput
                    labelText="City"
                    id="city"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    labelProps={{
                      shrink: true
                    }}
                    inputProps={{
                      required: true,
                      onChange: (e) => handleChangeTripOrderPickUpLocation(e, "pickUp", orderIndex),
                      value: order ? (order.pickUpLocation ? order.pickUpLocation.city : null) : (tripOrder.pickUpLocation ? tripOrder.pickUpLocation.city : ""),
                    }}
                  />
                </GridItem>
                <GridItem xs={4}>
                  <CustomInput
                    labelText="State"
                    id="state"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    labelProps={{
                      shrink: true
                    }}
                    inputProps={{
                      required: true,
                      onChange: (e) => handleChangeTripOrderPickUpLocation(e, "pickUp", orderIndex),
                      value: order ? (order.pickUpLocation ? order.pickUpLocation.state : null) : (tripOrder.pickUpLocation ? tripOrder.pickUpLocation.state : ""),
                    }}
                  />
                </GridItem>
                <GridItem xs={4}>
                  <CustomInput
                    labelText="Zip"
                    id="zip"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    labelProps={{
                      shrink: true
                    }}
                    inputProps={{
                      required: true,
                      onChange: (e) => handleChangeTripOrderPickUpLocation(e, "pickUp", orderIndex),
                      value: order ? (order.pickUpLocation ? order.pickUpLocation.zip : null) : (tripOrder.pickUpLocation ? tripOrder.pickUpLocation.zip : ""),
                    }}
                  />
                </GridItem>

              </GridContainer>
            }

            <GridContainer>
              <GridItem xs>
                <b>Drop Off Location:</b>
                <FormControlLabel
                  control={
                    <Switch
                      checked={order.isDropOff}
                      onChange={handleSwitchChangeOrder("isDropOff", order.id)}
                      value="isDropOff"
                      classes={{
                        switchBase: classes.switchBase,
                        checked: classes.switchChecked,
                        icon: classes.switchIcon,
                        iconChecked: classes.switchIconChecked,
                        bar: classes.switchBar,
                      }}
                    />
                  }
                  classes={{
                    label: classes.label,
                  }}
                  style={{ marginLeft: "10px" }}
                />
              </GridItem>

              <GridItem xs>
                <b style={{ paddingRight: '20px' }}>Drop Off By:</b>
                <DateTimePicker
                  onChange={(date) =>
                    handleDateTimeTripOrderDropOffChange(
                      date
                    )
                  }
                  value={order ? order.dropOffBy : (tripOrder.dropOffBy ? tripOrder.dropOffBy.toDate() : null)}
                />
              </GridItem>
            </GridContainer>

            {order.isDropOff &&
              <GridContainer>
                <GridItem xs={12}>
                  <Divider />
                  <GridContainer xs={12}>
                    <GridItem xs={6}>
                      <br />
                      <p>
                        <b>Drop Off Location:</b>
                      </p>
                    </GridItem>
                    <GridItem xs={6} >
                      <Button
                        color="primary"
                        onClick={() => handleClearDropOff(orderIndex)}
                      >
                        Clear Location
                      </Button>
                    </GridItem>

                  </GridContainer>
                </GridItem>
                <GridItem xs={12}>
                  <PrototypeExploreAssignUser
                    labelText={"Search Business Name"}
                    trip={true}
                    collection={"TEST-vendors"}
                    collection2={"TEST-shippers"}
                    id='dropOffQuery'
                    onChange={(e) => setDropOffQuery(e.target.value)}
                    value={dropOffQuery}
                    assignUser={(...args) => assignBusiness(...args, 'dropOff')}
                  />
                  {order.dropOffLocation &&
                    order.dropOffLocation.entityName && (
                      <p>{order.dropOffLocation.entityName}</p>
                    )}
                </GridItem>
                <GridItem xs={12}>
                  <CustomInput
                    labelText="Business Name"
                    id="entityName"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    labelProps={{
                      shrink: true
                    }}
                    inputProps={{
                      required: true,
                      onChange: (e) => handleChangeTripOrderDropOffLocation(e, "dropOff", orderIndex),
                      value: order ? (order.dropOffLocation ? order.dropOffLocation.entityName : null) : (tripOrder.dropOffLocation ? tripOrder.dropOffLocation.entityName : ""),
                    }}
                  />
                </GridItem>
                <GridItem xs={12}>
                  <CustomInput
                    labelText="Address"
                    id="address"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    labelProps={{
                      shrink: true
                    }}
                    inputProps={{
                      required: true,
                      onChange: (e) => handleChangeTripOrderDropOffLocation(e, "dropOff", orderIndex),
                      value: order ? (order.dropOffLocation ? order.dropOffLocation.address : null) : (tripOrder.dropOffLocation ? tripOrder.dropOffLocation.address : ""),
                    }}
                  />
                </GridItem>
                <GridItem xs={4}>
                  <CustomInput
                    labelText="City"
                    id="city"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    labelProps={{
                      shrink: true
                    }}
                    inputProps={{
                      required: true,
                      onChange: (e) => handleChangeTripOrderDropOffLocation(e, "dropOff", orderIndex),
                      value: order ? (order.dropOffLocation ? order.dropOffLocation.city : null) : (tripOrder.dropOffLocation ? tripOrder.dropOffLocation.city : ""),
                    }}
                  />
                </GridItem>
                <GridItem xs={4}>
                  <CustomInput
                    labelText="State"
                    id="state"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    labelProps={{
                      shrink: true
                    }}
                    inputProps={{
                      required: true,
                      onChange: (e) => handleChangeTripOrderDropOffLocation(e, "dropOff", orderIndex),
                      value: order ? (order.dropOffLocation ? order.dropOffLocation.state : null) : (tripOrder.dropOffLocation ? tripOrder.dropOffLocation.state : ""),
                    }}
                  />
                </GridItem>
                <GridItem xs={4}>
                  <CustomInput
                    labelText="Zip"
                    id="zip"
                    formControlProps={{
                      fullWidth: true,
                    }}
                    labelProps={{
                      shrink: true
                    }}
                    inputProps={{
                      required: true,
                      onChange: (e) => handleChangeTripOrderDropOffLocation(e, "dropOff", orderIndex),
                      value: order ? (order.dropOffLocation ? order.dropOffLocation.zip : null) : (tripOrder.dropOffLocation ? tripOrder.dropOffLocation.zip : ""),
                    }}
                  />
                </GridItem>

              </GridContainer>
            }

          </GridItem>
        }
        {/* <GridItem xs={12}>
          <FormControl
            fullWidth
            className={classes.selectFormControl}
          >
            <InputLabel
              htmlFor="legType"
              className={classes.selectLabel}
            >
              Stop Type:
            </InputLabel>
            <Select
              MenuProps={{
                className: classes.selectMenu,
              }}
              classes={{
                select: classes.select,
              }}
              value={order.legType ? order.legType : (tripOrder && tripOrder.legType)}
              onChange={handleChangeLegType}
              inputProps={{
                id: "legType",
                name: "legType",
              }}
            >
              {legTypes.map((type, i) => (
                <MenuItem
                  classes={{
                    root: classes.selectMenuItem,
                  }}
                  value={type}
                  key={i}
                >
                  {type}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </GridItem> 
        <GridItem xs={12}>
          <CustomInput
            labelText={`${isDollar ? "$" : "%"} Expense`}
            id={`${isDollar ? "$" : "%"}-rate`}
            formControlProps={{
              fullWidth: true,
            }}
            inputProps={{
              type: "number",
              required: true,
              value:
                isDollar && countDecimals(rate) > 2 ? rate.toFixed(2) : rate,
              onClick: (e) => e.stopPropagation(),
              onChange: (e) => handleChangeRate(e),
              startAdornment: (
                <div
                  style={{ margin: "auto 8px", cursor: "pointer" }}
                  onClick={toggleRateType}
                >
                  {isDollar ? "$" : "%"}
                </div>
              ),
            }}
          />
        </GridItem>*/}
      </GridContainer>
    </Card >
  );
};



// WEBPACK FOOTER //
// ./src/views/Settlements/OrderCard.jsx